import { render, staticRenderFns } from "./checkbox-button.vue?vue&type=template&id=628076df&scoped=true&"
import script from "./checkbox-button.vue?vue&type=script&lang=js&"
export * from "./checkbox-button.vue?vue&type=script&lang=js&"
import style0 from "./checkbox-button.vue?vue&type=style&index=0&id=628076df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628076df",
  null
  
)

export default component.exports